import { Link } from "react-router-dom";
import {
  HeaderWrapper,
  CoinWrapper,
  CoinAmount,
  CoinDivider,
  CoinNumber,
} from "./style";
//mui
import { orange } from "@mui/material/colors";
import PaidIcon from "@mui/icons-material/Paid";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
//utils
import useWindowDimensions from "../../../utils/useMediaQuery";
import { useAuth } from "../../../utils/hooks/useAuth";
import { useSelector } from "react-redux";
import { selectAuthData } from "../../../redux/features/auth/authSlice";
import { userDashboardRoute } from "../../../utils/routes/Routes";
import RowContainer from "../../common/RowContainer";
import { KeyboardArrowLeftRounded } from "@mui/icons-material";
import { Avatar, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

const Header = ({ onOpenDrawer }) => {
  const { width } = useWindowDimensions();
  const auth = useAuth();
  const userData = useSelector(selectAuthData);
  const handleOpenDrawer = () => {
    onOpenDrawer(true);
  };

  return (
    <HeaderWrapper>
      <RowContainer style={{ width: "100%" }}>
        {auth?.auth?.userData?.role === "user" ? (
          <CoinWrapper>
            <CoinAmount>
              <MonetizationOnRoundedIcon sx={{ color: "#656575" }} />
              {width > 1279 && (
                <span>
                  {" "}
                  <FormattedMessage id="dashboard.header.credits"></FormattedMessage>
                </span>
              )}
              <CoinNumber>{userData?.userData?.credits}</CoinNumber>
            </CoinAmount>
            <CoinDivider />
            <CoinAmount>
              <CreditCardRoundedIcon sx={{ color: "#656575" }} />
              <Link to={userDashboardRoute.buyCredits}>
                <span className="buy-credit-span">
                  {" "}
                  <FormattedMessage id="dashboard.header.buyCredits"></FormattedMessage>
                </span>
              </Link>
            </CoinAmount>
          </CoinWrapper>
        ) : (
          <div></div>
        )}
        <RowContainer minGap align="center" onClick={handleOpenDrawer}>
          <KeyboardArrowLeftRounded sx={{ cursor: "pointer" }} />
          <Avatar
            sx={{
              height: "24px",
              width: "24px",
              backgroundColor: "var(--main-color)",
              padding: "14px",
            }}
          >
            <Typography color="#fff" component="p" fontSize="14px">
              {auth?.auth?.userData?.first_name.charAt(0)}
            </Typography>
          </Avatar>
          <Typography
            color="var(--text-secondary)"
            component="p"
            fontSize="16px"
          >
            {auth?.auth?.userData?.first_name}
          </Typography>
        </RowContainer>
      </RowContainer>
    </HeaderWrapper>
  );
};

export default Header;
